export default __webpack_public_path__ + "52b61523e79a7310b28a7ff640054f78.jpeg";